<template>
  <vs-popup
    :title="$t('UsersList') + roleCurrent.name"
    fullscreen
    :active.sync="popupActive"
  >
    <add-user-to-role-popup
      :showUserList="onAddUser"
      @finish="onUserListPopupFinish"
      :roleCurrent="roleCurrent"
    ></add-user-to-role-popup>
    <div class="vx-row" v-if="loaded">
      <div>
        <vs-button
          color="success"
          type="gradient"
          icon-pack="feather"
          icon="icon-plus"
          class="mx-3 mb-3 p-2"
          @click.prevent="addUser()"
          >افزودن کاربر جدید</vs-button
        >
      </div>

      <div class="vx-col w-full mb-base">
        <data-grid
          ref="grid"
          stripe
          :data-source="gridDataSource"
          :search-data="gridSearchData"
          :columns="[
            { title: $t('PhoneNumber'), sort: 'PhoneNumber' },
            { title: $t('Action') },
          ]"
        >
          <template slot-scope="{ row }">
            <td style="width: 80%">
              {{ row.userName }}
            </td>
            <td style="width: 20%">
              <vs-button
                radius
                color="danger"
                size="small"
                type="gradient"
                icon-pack="feather"
                icon="icon-x"
                @click.prevent="unassignUserInRole(row.id)"
                class="d-inline"
              ></vs-button>
            </td>
          </template>
        </data-grid>
      </div>
    </div>
  </vs-popup>
</template>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import AddUserToRolePopup from "./AddUserToRolePopup.vue";
import { mapActions } from "vuex";
export default {
  name: "user-management-Roles-UserPopup",
  props: {
    show: { default: false },
    urlApiForUserList: {},
    roleCurrent: {},
  },
  data() {
    return {
      loaded: false,
      gridDataSource: {
        type: "app",
        service: "",
      },
      gridSearchData: {},
      modelForUnAssign: {},
      onAddUser: false,
    };
  },
  computed: {
    popupActive: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        this.gridDataSource.service = this.urlApiForUserList;
        setTimeout(() => {
          this.loaded = true;
        }, 200);
      } else {
        this.loaded = false;
      }
    },
  },

  components: {
    DataGrid,
    AddUserToRolePopup,
  },
  methods: {
    ...mapActions({
      unAssignUser: "user/updateUserRoles",
      getListRolesUser: "user/fetchByRoleId",
    }),
    addUser() {
      this.onAddUser = true;
    },
    onUserListPopupFinish() {
      this.onAddUser = false;
      this.$refs.grid.renderGrid();
    },
    unassignUserInRole(id) {
      this.getListRolesUser(id).then((r) => {
        for (let index = 0; index < r.length; index++) {
          if (r[index].roleId == this.roleCurrent.id) {
            r[index].isSelected = false;
          }
        }
        this.modelForUnAssign.userRoles = r;
      });

      this.modelForUnAssign.userId = id;

      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.unAssignUser(this.modelForUnAssign).then(() => {
            this.$emit("finish");
          });
        }
      });
    },
  },
};
</script>
